import React, { useEffect, useState } from 'react'
import { Form, Input, Button, DatePicker, Select, Row, Col, Radio, Space, Tabs, Card, Menu, InputNumber } from 'antd'

import _ from 'lodash'
import moment from 'moment'
import { category, level, scheduleType } from '../../../shared/enums'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import SettingsPool from './properties/SettingsPool'
import SettingsCheckIn from './properties/SettingCheckin'
import SettingsTable from './properties/SettingsTable'
import SettingsBestof from './properties/SettingBestof'

import './css/tournament-properties.css'

const { TabPane } = Tabs

const TournamentProperties = (props) => {
  const [categories, setCategories] = useState([])
  const [levels, setLevels] = useState([])
  const [poolPromotion, setPoolPromotion] = useState({})
  const [tablePromotion, setTablePromotion] = useState({})
  const [schedule, setSchedule] = useState([])
  const [selectedSchedule, setSelectedSchedule] = useState('')
  const [initialValues, setInitialValues] = useState({
    title: _.get(props.tournament, 'title', ''),
    organizer: _.get(props.tournament, 'organizer', ''),
    web_site: _.get(props.tournament, 'web_site', ''),
    location: _.get(props.tournament, 'location'),
    date: _.get(props.tournament, 'date') ? moment(_.get(props.tournament, 'date'), 'YYYY-MM-DD') : moment(new Date(), 'YYYY-MM-DD'),
    weapon: _.get(props.tournament, 'weapon'),
    gender: _.get(props.tournament, 'gender'),
    category: _.get(props.tournament, 'category'),
    level: _.get(props.tournament, 'level'),
    checkin: moment(_.get(props.tournament, 'checkin', '12:00 PM'), 'hh:mm A'),
    scratch: moment(_.get(props.tournament, 'scratch', '1:00 PM'), 'hh:mm A'),
    uuid: _.get(props.tournament, 'uuid', ''),
    tournamentBracketWinValue: _.get(props.tournament, 'tournamentBracketWinValue', 20)
  })

  useEffect(() => {
    setCategories(category)
    setLevels(level)

    if (props?.edit) {
      setSchedule(props.tournament.schedule.filter(s => s !== 'final'))
    } else {
      setSchedule([scheduleType.CHECKIN.id, scheduleType.POOLS.id, scheduleType.TABLE.id])
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const values = {
      title: _.get(props.tournament, 'title', ''),
      organizer: _.get(props.tournament, 'organizer', ''),
      web_site: _.get(props.tournament, 'web_site', ''),
      location: _.get(props.tournament, 'location'),
      date: _.get(props.tournament, 'date') ? moment(_.get(props.tournament, 'date'), 'YYYY-MM-DD') : moment(new Date(), 'YYYY-MM-DD'),
      weapon: _.get(props.tournament, 'weapon'),
      gender: _.get(props.tournament, 'gender'),
      category: _.get(props.tournament, 'category'),
      level: _.get(props.tournament, 'level'),
      checkin: moment(_.get(props.tournament, 'checkin', '12:00 PM'), 'hh:mm A'),
      scratch: moment(_.get(props.tournament, 'scratch', '1:00 PM'), 'hh:mm A'),
      uuid: _.get(props.tournament, 'uuid', ''),
      tournamentBracketWinValue: _.get(props.tournament, 'tournamentBracketWinValue', 20)
    }

    _.get(props.tournament, 'schedule', []).forEach((item, index) => {
      let poolsCount = 0
      if (item === scheduleType.POOLS.id) {
        poolsCount += 1

        values[`pool_name_${index}`] = _.get(props, `tournament.pool_name_${index}`, `Qualifiers #${poolsCount}`)
        values[`pool_score_${index}`] = _.get(props, `tournament.pool_score_${index}`, 8)
        values[`pool_duration_${index}`] = _.get(props, `tournament.pool_duration_${index}`, '01:30')
        values[`pool_promotion_${index}`] = _.get(props, `tournament.pool_promotion_${index}`, 'all')
        values[`pool_promotion_exact_${index}`] = _.get(props, `tournament.pool_promotion_exact_${index}`, 8)
      }
      if (item === scheduleType.TABLE.id) {
        const count = props.tournament.schedule.reduce((total, x) => (x === scheduleType.TABLE.key ? total + 1 : total), 0)
        values[`table_fenceoff_${index}`] = true
        values[`table_name_${index}`] = _.get(props, `tournament.table_name_${index}`, `${scheduleType.TABLE.label} #${count}`)
        values[`table_score_${index}`] = _.get(props, `tournament.table_score_${index}`, 12)
        values[`table_promotion_${index}`] = _.get(props, `tournament.table_promotion_${index}`, 'all')
        values[`table_duration_${index}`] = _.get(props, `tournament.table_duration_${index}`, '02:00')
      }
      if (item === scheduleType.BESTOF.id) {
        const count = props.tournament.schedule.reduce((total, x) => (x === scheduleType.BESTOF.key ? total + 1 : total), 0)
        values[`table_fenceoff_${index}`] = true
        values[`table_name_${index}`] = _.get(props, `tournament.table_name_${index}`, `${scheduleType.BESTOF.label} #${count}`)
        values[`table_score_${index}`] = _.get(props, `tournament.table_score_${index}`, 8)
        values[`table_promotion_${index}`] = _.get(props, `tournament.table_promotion_${index}`, 'all')
        values[`table_duration_${index}`] = _.get(props, `tournament.table_duration_${index}`, '01:30')
      }
    })
    setInitialValues(values)

    setPoolPromotion(_.get(props.tournament, 'pool_promotion', {}))
  }, [props.tournament])

  useEffect(() => {
    const values = _.cloneDeep(initialValues)

    schedule.forEach((item, index) => {
      let poolsCount = 0
      let bracketCount = 0
      let bestOfCount = 0
      if (item === scheduleType.POOLS.id) {
        poolsCount += 1

        values[`pool_name_${index}`] = _.get(props, `tournament.pool_name_${index}`, `Qualifiers #${poolsCount}`)
        values[`pool_score_${index}`] = _.get(props, `tournament.pool_score_${index}`, 8)
        values[`pool_duration_${index}`] = _.get(props, `tournament.pool_duration_${index}`, '01:30')
        values[`pool_promotion_${index}`] = _.get(props, `tournament.pool_promotion_${index}`, 'all')
        values[`pool_promotion_exact_${index}`] = _.get(props, `tournament.pool_promotion_exact_${index}`, 8)
      }
      if (item === scheduleType.TABLE.id) {
        bracketCount += 1
        values[`table_fenceoff_${index}`] = true
        values[`table_name_${index}`] = _.get(props, `tournament.table_name_${index}`, `${scheduleType.TABLE.label} #${bracketCount}`)
        values[`table_score_${index}`] = _.get(props, `tournament.table_score_${index}`, 12)
        values[`table_promotion_${index}`] = _.get(props, `tournament.table_promotion_${index}`, 'all')
        values[`table_duration_${index}`] = _.get(props, `tournament.table_duration_${index}`, '02:00')
      }
      if (item === scheduleType.BESTOF.id) {
        bestOfCount += 1
        values[`table_fenceoff_${index}`] = true
        values[`table_name_${index}`] = _.get(props, `tournament.table_name_${index}`, `${scheduleType.BESTOF.label} #${bestOfCount}`)
        values[`table_score_${index}`] = _.get(props, `tournament.table_score_${index}`, 8)
        values[`table_promotion_${index}`] = _.get(props, `tournament.table_promotion_${index}`, 'all')
        values[`table_duration_${index}`] = _.get(props, `tournament.table_duration_${index}`, '01:30')
      }
    })

    setInitialValues(values)
    // eslint-disable-next-line
  }, [schedule])

  const onFinish = (values) => {
    values.date = moment(values.date).format('YYYY-MM-DD')
    values.checkin = moment(_.get(values, 'checkin', '12:00 PM'), 'hh:mm A').format('hh:mm A')
    values.scratch = moment(_.get(values, 'scratch', '1:00 PM'), 'hh:mm A').format('hh:mm A')

    schedule.push('final')
    values.schedule = schedule

    values.schedule.forEach((s, index) => {
      if (s === 'table' || s === 'bestof') {
        if (values[`table_bestof_${index}`]) {
          values[`table_bestof_${index}`] = _.toNumber(values[`table_bestof_${index}`])
        }
        if (values[`table_promotion_${index}`]) {
          values[`table_promotion_${index}`] = _.toNumber(values[`table_promotion_${index}`])
        }
        if (schedule[index + 1] !== 'final') {
          delete initialValues[`table_fenceoff_${index}`]
        } else {
          delete values[`table_promotion_${index}`]
        }
      }
    })

    Object.keys(values).forEach(key => values[key] === undefined && delete values[key])

    const tournamentValues = Object.assign({}, initialValues, values)

    props.handleOk(tournamentValues)
  }

  const onPoolPromotionUpdate = (e) => {
    const value = {}
    value[e.target.name] = e.target.value
    setPoolPromotion(prevState => Object.assign({}, prevState, value))
  }

  const onTablePromotionUpdate = (e) => {
    const value = {}
    value[e.target.name] = e.target.value
    setTablePromotion(prevState => Object.assign({}, prevState, value))
  }

  const handleAddRemoveScheduleItem = (e) => {
    if (e.key === 'remove') {
      if (selectedSchedule !== '' && selectedSchedule > 0) {
        setSchedule(prevState => {
          prevState.splice(selectedSchedule, 1)
          return prevState
        })
        setSelectedSchedule('')
      }
      return
    }

    setSchedule(prevState => [...prevState, e.key])
  }

  return (
    <div className='tournament-properties'>
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={(errorInfo) => { console.log('Failed:', errorInfo) }}
        autoComplete='off'
        initialValues={initialValues}
      >
        <Tabs defaultActiveKey='1' type='card'>
          <TabPane tab='Event' key='1'>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item label='Date' name='date' style={{ marginBottom: '5px' }}>
                  <DatePicker style={{ width: '250px' }} />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: '0' }}
                  label='Title'
                  name='title'
                  rules={[
                    {
                      required: true,
                      message: 'Please input a title!'
                    }
                  ]}
                >
                  <Input style={{ width: '250px' }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Card>
                  <div className='card-title'>Overview</div>
                  <Form.Item label='Organizer' name='organizer'>
                    <Input />
                  </Form.Item>
                  <Form.Item label='Web Site' name='web_site'>
                    <Input />
                  </Form.Item>
                  <Form.Item label='Location' name='location'>
                    <Input />
                  </Form.Item>
                </Card>
              </Col>
              <Col span={12}>
                <Card>
                  <div className='card-title'>Type</div>
                  <Form.Item label='Gender' name='gender'>
                    <Select>
                      <Select.Option key='mixed' value='mixed'>Mixed</Select.Option>
                      <Select.Option key='female' value='female'>Female</Select.Option>
                      <Select.Option key='male' value='male'>Male</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label='Category' name='category'>
                    <Select>
                      {_.map(categories, (o) => <Select.Option key={o.id} value={o.id}>{o.label}</Select.Option>)}
                    </Select>
                  </Form.Item>
                  <Form.Item label='Level' name='level'>
                    <Select>
                      {_.map(levels, (o) => <Select.Option key={o.id} value={o.id}>{o.label}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tab='Layout' key='2'>

            <Row className='configuration-buttons'>
              {!props?.edit
                ? (
                  <Menu
                    mode='horizontal'
                    selectable={false}
                    triggerSubMenuAction='click'
                    onClick={handleAddRemoveScheduleItem}
                    expandIcon={<PlusOutlined />}
                    items={[
                      {
                        label: 'Add',
                        key: 'SubMenu',
                        icon: <PlusOutlined style={{ fontSize: 20 }} />,
                        children: [scheduleType.POOLS, scheduleType.TABLE, scheduleType.BESTOF, scheduleType.SPLIT]
                      },
                      {
                        label: 'Remove',
                        key: 'remove',
                        icon: <MinusOutlined style={{ fontSize: 20 }} />
                      }
                    ]}
                    style={{ width: '100%' }}
                  />
                  )
                : ''}
            </Row>

            <Row gutter={[8, 16]}>
              <Col span={6} className='schedule'>
                <Card>
                  <div className='card-title'>Schedule</div>
                  <Radio.Group onChange={(e) => { setSelectedSchedule(e.target.value) }} value={selectedSchedule} style={{ width: '100%' }}>
                    <Space direction='vertical' style={{ width: '100%' }}>
                      {schedule.map((s, index) => {
                        return <Radio.Button style={{ width: '6.5em', textAlign: 'center' }} key={index} value={index}>{scheduleType[_.toUpper(s)].label}</Radio.Button>
                      })}
                    </Space>
                  </Radio.Group>
                </Card>
              </Col>
              <Col span={18} className='settings'>
                <Card>
                  <div className='card-title'>Settings</div>
                  {schedule.map((s, index) => {
                    if (s === scheduleType.POOLS.id) return (<div key={`schedule-${index}`}><SettingsPool schedule={schedule} selectedSchedule={selectedSchedule} onPoolPromotionUpdate={onPoolPromotionUpdate} poolPromotion={poolPromotion} hidden={selectedSchedule !== index} index={index} tournament={props.tournament} initialValues={initialValues} /></div>)
                    if (s === scheduleType.CHECKIN.id) return (<div key={`schedule-${index}`}><SettingsCheckIn schedule={schedule} selectedSchedule={selectedSchedule} hidden={selectedSchedule !== index} index={index} tournament={props.tournament} /></div>)
                    if (s === scheduleType.TABLE.id) return (<div key={`schedule-${index}`}><SettingsTable type={scheduleType.TABLE} schedule={schedule} selectedSchedule={selectedSchedule} onTablePromotionUpdate={onTablePromotionUpdate} tablePromotion={tablePromotion} hidden={selectedSchedule !== index} index={index} tournament={props.tournament} /></div>)
                    if (s === scheduleType.BESTOF.id) return (<div key={`schedule-${index}`}><SettingsBestof type={scheduleType.BESTOF} schedule={schedule} selectedSchedule={selectedSchedule} onTablePromotionUpdate={onTablePromotionUpdate} tablePromotion={tablePromotion} hidden={selectedSchedule !== index} index={index} tournament={props.tournament} /></div>)
                    return (React.Fragment)
                  })}
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane tab='Settings' key='3'>
            <Row>
              <Col span={24}>
                <Card>
                  <div className='card-title'>Tournament Points</div>
                  <Form.Item label='Points/Bracket Win' name='tournamentBracketWinValue'>
                    <InputNumber />
                  </Form.Item>
                  <Row>
                    <Col>
                      Note: "Best Of" Bracket match wins are calculated at bracket win value / 2
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
        <Row className='tournament-control-area' style={{ paddingTop: '15px' }}>
          <Col span={24}>
            <Form.Item style={{ float: 'right', whiteSpace: 'nowrap', marginBottom: '0' }}>
              <Button type='primary' shape='round' htmlType='submit'>
                Save
              </Button>
              <Button htmlType='button' shape='round' onClick={props.handleCancel}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default TournamentProperties
